import { Injectable } from '@angular/core';

import { TdDataTableSortingOrder, ITdDataTableColumn } from '../data-table.component';
export class TdDataTableService {
/**
 * params:
 * - data: any[]
 * - searchTerm: string
 * - ignoreCase: boolean = false
 * - excludedColumns: string[] = []
 * 
 * Searches [data] parameter for [searchTerm] matches and returns a new array with them.
 * @param {?} data
 * @param {?} searchTerm
 * @param {?=} ignoreCase
 * @param {?=} excludedColumns
 * @return {?}
 */
filterData(data: any[], searchTerm: string, ignoreCase: boolean = false, excludedColumns?: string[]): any[] {
    let /** @type {?} */ filter: string = searchTerm ? (ignoreCase ? searchTerm.toLowerCase() : searchTerm) : '';
    if (filter) {
      data = data.filter((item: any) => {
        const /** @type {?} */ res: any = Object.keys(item).find((key: string) => {
          if (!excludedColumns || excludedColumns.indexOf(key) === -1) {
            const /** @type {?} */ preItemValue: string = ('' + item[key]);
            const /** @type {?} */ itemValue: string = ignoreCase ? preItemValue.toLowerCase() : preItemValue;
            return itemValue.indexOf(filter) > -1;
          }
        });
        return !(typeof res === 'undefined');
      });
    }
    return data;
  }
/**
 * params:
 * - data: any[]
 * - sortBy: string
 * - sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending
 * 
 * Sorts [data] parameter by [sortBy] and [sortOrder] and returns the sorted data.
 * @param {?} data
 * @param {?} sortBy
 * @param {?=} sortOrder
 * @return {?}
 */
sortData(data: any[], sortBy: string, sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending): any[] {
    if (sortBy) {
      data.sort((a: any, b: any) => {
        let /** @type {?} */ compA: any = a[sortBy];
        let /** @type {?} */ compB: any = b[sortBy];
        let /** @type {?} */ direction: number = 0;
        if (!Number.isNaN(Number.parseFloat(compA)) && !Number.isNaN(Number.parseFloat(compB))) {
          direction = Number.parseFloat(compA) - Number.parseFloat(compB);
        } else {
          if (compA < compB) {
            direction = -1;
          } else if (compA > compB) {
            direction = 1;
          }
        }
        return direction * (sortOrder === TdDataTableSortingOrder.Descending ? -1 : 1);
      });
    }
    return data;
  }
/**
 * params:
 * - data: any[]
 * - fromRow: number
 * - toRow: : number
 * 
 * Returns a section of the [data] parameter starting from [fromRow] and ending in [toRow].
 * @param {?} data
 * @param {?} fromRow
 * @param {?} toRow
 * @return {?}
 */
pageData(data: any[], fromRow: number, toRow: number): any[] {
    if (fromRow >= 1) {
      data = data.slice(fromRow - 1, toRow);
    }
    return data;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TdDataTableService_tsickle_Closure_declarations() {
/** @type {?} */
TdDataTableService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdDataTableService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
